<script lang="ts" setup>
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { SCREEN } from '@/utils/segment'
import OnboardingContent from '@/components/OnboardingContent/index.vue'
import OnboardingStepsModal from '@/components/BrandedV2/OnboardingStepsModal/index.vue'
import { useThemeStore } from '@/stores/useThemeStore'
import { useSearchFiltersStore } from '@/stores/searchFiltersStore'

const themeStore = useThemeStore()
const isLoading = ref(false)
const searchFiltersStore = useSearchFiltersStore()

await callOnce(async () => {
  await searchFiltersStore.initialize()
})

const { currentFilters } = storeToRefs(searchFiltersStore)

definePageMeta({
  layout: 'empty'
})

</script>

<script lang="ts">
export default {
  name: 'OnboardingPage'
}
</script>

<template>
  <OnboardingStepsModal
    v-if="themeStore.isV2"
    :loading="isLoading"
    :screen="SCREEN.ONBOARDING"
    :initial-filters="currentFilters" />

  <OnboardingContent v-else />
</template>
